export const signerState: { [key: string]: any } = {
    firstName: '',
    lastName: '',
    birthdate: '',
    birthplace: '',
    citizenship: '',
    nationality: '',
    email: '',
    mobilePhoneNumber: '',
    streetName: '',
    houseNumber: '',
    addressAddition: '',
    postalCode: '',
    city: '',
    country: '',
    state: '',
    termsAndConditionsConfirmed: '',
    consentGivenAt: '',
    authority: '',
};
